/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../baseClasses/dataMaintenance.interface.ts"/>


module Meevo.Components.Controls {

    export type IMobileLayoutType = 'stacked'| 'stretched' | undefined;

    class MeevoSelectComponent implements angular.IComponentController {

        static $inject = [
            'meevo.components.common.DataService',
            '$translate',
        ];

        public list: any[];

        public contentKey: string;
        public url: string;
        public labelKey?: string;
        public valueKey?: string;
        public simpleArray?: boolean;
        public required?: boolean;
        public hideIfEmpty?: boolean;
        public model: any;
        public requestData?: any;
        public requestMethod?: string;
        public allLabel?: string;

        public hidden: boolean;
        public defaultValue: string;
        public mobileLayoutType: IMobileLayoutType;
        public message: string;

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
                    private $translate: angular.translate.ITranslateService) {
        }

        $onInit() {
            this.labelKey = this.labelKey || 'label';
            this.valueKey = this.valueKey || 'value';
            this.list = this.list || [];
            this.requestData = this.requestData || {};
            this.requestMethod = this.requestMethod || 'GET';
            this.hidden = false;
            this.message = '';

            if(this.defaultValue)
                this.model = this.defaultValue;

            this.preloadData();
        }

        preloadData() {
            if (!this.url) {
                return;
            }

            this.dataService
                .customMethodData('api/' + this.url, this.requestMethod, this.requestData)
                .then((res: {data: any[];}) => {
                    this.hidden = this.hideIfEmpty && res.data.length === 0;

                    if (!this.required && this.allLabel) {
                        this.list = [{
                            [this.labelKey]: this.allLabel,
                            [this.valueKey]: null
                        }];
                    } else {
                        this.list = [];
                    }

                    if (this.simpleArray) {
                        this.list.push(...res.data.map(row => ({
                            [this.labelKey]: row,
                            [this.valueKey]: row
                        })));
                    } else {
                        this.list.push(...res.data);
                    }

                    this.handleDuplicates();

                    if (this.list.length > 0 && !this.model) {
                        this.model = this.list[0][this.valueKey];
                    }
                });
        }

        private async handleDuplicates() {
            if (!this.list || this.list.length === (new Set(this.list.map(item => item[this.labelKey])).size))
                return;

            const nameCounts: { [key: string]: number} = {};
            const duplicateNamesList: string[] = [];
            let key: string;

            this.list.forEach(row => {
                key = row[this.labelKey];
                if (key in nameCounts) {
                    duplicateNamesList.push(key)
                    nameCounts[key] += 1;
                } else {
                    nameCounts[row[this.labelKey]] = 1;
                }
            });

            duplicateNamesList.forEach((name: string) => {
                this.list
                    .filter((item: object) => item[this.labelKey] === name)
                    .forEach((item: object, index: number) => item[this.labelKey] += ' (' + (index + 1) + ')');
            });

            this.list.sort((a: object, b: object) => a[this.labelKey].localeCompare(b[this.labelKey]));

            if (this.requestData && this.requestData.criteria && this.requestData.criteria.orderAscDesc === 'Descending')
               this.list.reverse();

            this.message = this.$translate.instant(
                "MESSAGE_THIS_LIST_HAS_DUPLICATE_NAMES",
                { duplicateNames: duplicateNamesList.join(', ') }
            );
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoSelect', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/select/select.template.html',
            controller: MeevoSelectComponent,
            controllerAs: '$ctrl',
            bindings: {
                contentKey: '@?',
                url: '@?',
                labelKey: '@?',
                valueKey: '@?',
                simpleArray: '=?',
                model: '=?ngModel',
                list: '=?',
                hideIfEmpty: '=?',
                requestData: '=?',
                requestMethod: '@?',
                allLabel: '@?',
                required: '=?ngRequired',
                change: '&?ngChange',
                disabled: '=?ngDisabled',
                defaultValue: '=?defaultValue',
                mobileLayoutType: '=?'
            }
        });
}
